export default "__VITE_ASSET__LVJqpRkG__"